import React, { Component } from "react";
import Icon from '@material-ui/core/Icon';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError } from "../../../actions/action-creators";
import moment from "moment";
import PartnerDayMap from "./partner_day_map";

const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const formatHours = (minutes) => {
    if (!minutes) return "-";
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    return h ? `${h}h ${m}m` : `${m}m`;
}

class PartnerActivityCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            month: moment().format("YYYY-MM"),
            summary: {},
            selectedDate: null,
        }
    }

    componentDidMount() {
        this.fetchMonthSummary();
    }

    fetchMonthSummary = async () => {
        try {
            let resp = await ApiEndpoints.FieldSurveyActivity.dayActivityByMonth({
                user_id: this.props.userId,
                job_id: this.props.jobId,
                month: this.state.month
            });
            this.setState({ summary: resp.data.data || {} });
        }
        catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
        }
    }

    changeMonth = (delta) => {
        let month = moment(this.state.month, "YYYY-MM").add(delta, "month").format("YYYY-MM");
        this.setState({ month, summary: {} }, this.fetchMonthSummary);
    }

    render() {
        let { month, summary, selectedDate } = this.state;
        let monthMoment = moment(month, "YYYY-MM");
        let daysInMonth = monthMoment.daysInMonth();
        let leadingBlanks = monthMoment.clone().startOf("month").day(); // 0=Sun
        let cells = [];
        for (let i = 0; i < leadingBlanks; i++) cells.push(null);
        for (let d = 1; d <= daysInMonth; d++) cells.push(d);

        return (
            <div>
                <div className="d-flex align-items-center justify-content-center mb-2">
                    <Icon style={{ cursor: "pointer" }} onClick={() => this.changeMonth(-1)}>chevron_left</Icon>
                    <span className="mx-3" style={{ fontWeight: 600, fontSize: 14 }}>{monthMoment.format("MMMM YYYY")}</span>
                    <Icon style={{ cursor: "pointer" }} onClick={() => this.changeMonth(1)}>chevron_right</Icon>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, maxWidth: 560, margin: "0 auto" }}>
                    {WEEKDAY_LABELS.map(label =>
                        <div key={label} style={{ textAlign: "center", fontSize: 11, fontWeight: 600, color: "#999" }}>{label}</div>
                    )}
                    {cells.map((day, i) => {
                        if (!day) return <div key={"blank-" + i} />;
                        let dateStr = monthMoment.clone().date(day).format("YYYY-MM-DD");
                        let dayData = summary[dateStr];
                        let isFuture = moment(dateStr).isAfter(moment(), "day");
                        return (
                            <div
                                key={dateStr}
                                onClick={() => !isFuture && this.setState({ selectedDate: dateStr })}
                                style={{
                                    border: "1px solid #eee",
                                    borderRadius: 4,
                                    padding: 6,
                                    minHeight: 62,
                                    cursor: isFuture ? "default" : "pointer",
                                    background: dayData ? "#fff8f8" : "#fff",
                                    opacity: isFuture ? 0.4 : 1,
                                }}
                            >
                                <div style={{ fontSize: 12, fontWeight: 600 }}>{day}</div>
                                {dayData &&
                                    <div style={{ fontSize: 10, lineHeight: 1.5, marginTop: 2 }}>
                                        <div className="text-muted">{formatHours(dayData.activeMinutes)}</div>
                                        {!!dayData.leadsCount && <div style={{ color: "#f1061c", fontWeight: 600 }}>{dayData.leadsCount} lead{dayData.leadsCount > 1 ? "s" : ""}</div>}
                                    </div>
                                }
                            </div>
                        );
                    })}
                </div>
                {selectedDate &&
                    <PartnerDayMap
                        userId={this.props.userId}
                        jobId={this.props.jobId}
                        date={selectedDate}
                        onClose={() => this.setState({ selectedDate: null })}
                    />
                }
            </div>
        );
    }
}

export default PartnerActivityCalendar;
